import { httpClient } from "./Api";

const END_POINT = "recuperos";

export default {
  request(data) {
    return httpClient.post(END_POINT + "/custom/request", data);
  },
};
